import React from 'react';
import { TimeInterval } from '@cotera/api';
import { ServiceSummaryCards } from '../components/service-summary-cards';
import { OrgInvocationsTable } from '../components/org-invocations-table';
import { ServiceFailureTypesTable } from '../components/service-failure-types-table';

interface GenericServiceTabProps {
  serviceName: string;
  timeInterval: TimeInterval;
}

export const GenericServiceTab: React.FC<GenericServiceTabProps> = ({
  serviceName,
  timeInterval,
}) => {
  return (
    <div className="space-y-6">
      <React.Suspense
        fallback={
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {Array.from({ length: 3 }).map((_, i) => (
              <div
                key={i}
                className="h-24 rounded-lg border bg-card animate-pulse"
              />
            ))}
          </div>
        }
      >
        <ServiceSummaryCards
          timeInterval={timeInterval}
          serviceFilter={serviceName}
        />
      </React.Suspense>

      <React.Suspense
        fallback={
          <div className="h-64 rounded-lg border bg-card animate-pulse" />
        }
      >
        <OrgInvocationsTable
          timeInterval={timeInterval}
          serviceFilter={serviceName}
        />
      </React.Suspense>

      <React.Suspense
        fallback={
          <div className="h-48 rounded-lg border bg-card animate-pulse" />
        }
      >
        <ServiceFailureTypesTable
          timeInterval={timeInterval}
          serviceFilter={serviceName}
        />
      </React.Suspense>
    </div>
  );
};
